import React from 'react';

const EmptySpacer = function(props) {
    return (
        <div className="empty-spacer"></div>
    );
}

export default EmptySpacer;
